import { Validators } from '@angular/forms';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { TableResponsiveTypeColumnEnum } from 'src/app/domain/registration/enums/table-responsive-type-column.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { ValueReferenceTypeEnum } from 'src/app/domain/registration/enums/value-reference-type.enum';

export const RELATIVE_URL = 'value-references';
export const COLUMNS_TO_SHOW_WEB = ['select','name', 'type', 'createdAt', 'actions'];
export const COLUMNS_TO_SHOW_MOBILE = COLUMNS_TO_SHOW_WEB;
export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [

  
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'type',
    display: 'PORCENTAGEM',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL_CURRENCY,
    link_show: true,
    property: 'name',
    display: 'VALOR DO SALARIO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'createdAt',
    display: 'CRIADO EM',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  
];

export const CES_CONFIG_FIELDS = [
  {
    type: TypeComponentFieldEnum.HIDDEN,
    name: 'id',
  },
  {
    type: TypeComponentFieldEnum.INPUT_CURRENCY,
    label: 'VALOR DE REFERENCIA',
    name: 'name',
    placeholder: 'Insira o nome',
    validation: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'REFERENCIA',
    name: 'type',
    options: Object.values(ValueReferenceTypeEnum),
    placeholder: 'Selecione uma opção',
    validators: [Validators.required],
  },
  {
    labelSave: 'Salvar',
    labelCancel: 'Cancelar',
    name: 'cancelSave',
    type: TypeComponentFieldEnum.CANCEL_SAVE,
  },
];
